import React, { useState } from 'react';
import products from 'data/can-store/products';
import ModernCardPopular from 'containers/can-store/modernTemplate/ModernCardPopular';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function ModernCarouselPopular(): JSX.Element {
	const [currentIndex, setCurrentIndex] = useState<number>(0);

	const slidesToShow = 7.2;
	const slideWidth = (100 - (slidesToShow - 1)) / slidesToShow;

	const totalSlides = products.length;

	const prevSlide = () => {
		const newIndex = Math.max(currentIndex - 1, 0);
		setCurrentIndex(newIndex);
	};

	const nextSlide = () => {
		let newIndex = currentIndex + 1;
		if (newIndex > totalSlides - slidesToShow) {
			newIndex = 0;
		}
		setCurrentIndex(newIndex);
	};

	return (
		<Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
			<Typography variant="h4" style={{ color: 'var(--csmd-cl-text-primary)' }}>
				Popular Items
			</Typography>
			<Box
				component="div"
				sx={{
					position: 'relative',
					overflow: 'hidden',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Box component="div" sx={{ width: '97%', overflow: 'hidden' }}>
					<Box
						component="div"
						sx={{
							display: 'flex',
							gap: '1rem',
							width: '100%',
							transform: `translateX(-${currentIndex * slideWidth}%)`,
							transition: 'transform 0.3s',
						}}
					>
						{products.map((item) => (
							<ModernCardPopular key={item.id} item={item} />
						))}
					</Box>
				</Box>
				<IconButton
					onClick={prevSlide}
					sx={{
						position: 'absolute',
						top: '50%',
						left: 0,
						transform: 'translateY(-25%)',
						zIndex: 1,
						backgroundColor: 'var(--csmd-cl-bg-icon_button)',
					}}
				>
					<ArrowBackIosIcon />
				</IconButton>
				<IconButton
					onClick={nextSlide}
					sx={{
						position: 'absolute',
						top: '50%',
						right: 0,
						transform: 'translateY(-50%)',
						zIndex: 1,
						backgroundColor: 'var(--csmd-cl-bg-icon_button)',
					}}
				>
					<ArrowForwardIosIcon />
				</IconButton>
			</Box>
		</Box>
	);
}

export default ModernCarouselPopular;
